/**
 * Asesor MG — WhatsApp ventas contextual (musclegrenade.cl)
 * Abre wa.me con mensajes inteligentes según página, producto y carrito.
 */
(function () {
  'use strict';

  var cfg = window.MG_SALES_ADVISOR || {};
  if (!cfg.enabled) return;

  var WA_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

  function page() {
    return cfg.page || {};
  }

  function customerName() {
    var c = cfg.customer || {};
    return c.firstName || c.name || '';
  }

  function greet() {
    return cfg.greeting || 'Hola Asesor MG';
  }

  function refTag() {
    var p = page();
    var parts = ['web', p.type || 'page'];
    if (p.type === 'cart' || p.cartCount > 0) parts[1] = 'cart';
    if (p.productHandle) parts.push(p.productHandle);
    return parts.join('-');
  }

  function cartSummaryFromItems(items, count) {
    if (!items || !items.length) return '';
    var first = items[0].title || '';
    var extra = (count || items.length) - 1;
    return extra > 0 ? first + ' +' + extra : first;
  }

  function cartPayloadTag(p) {
    p = p || page();
    if (!p.cartItems || !p.cartItems.length) return '';
    try {
      var payload = {
        items: p.cartItems.map(function (i) {
          return { h: i.handle, v: i.variant_id, t: i.title, q: i.quantity, p: i.price_clp };
        }),
        total: p.cartTotalClp || 0,
      };
      if (p.cartUrl) payload.url = p.cartUrl;
      return ' [cart:' + JSON.stringify(payload) + ']';
    } catch (e) {
      return '';
    }
  }

  function fetchLiveCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;
        return {
          cartCount: cart.item_count || cart.items.length,
          cartTotalClp: Math.round((cart.total_price || 0) / 100),
          cartItems: cart.items.map(function (i) {
            return {
              handle: i.handle,
              variant_id: i.variant_id,
              title: i.product_title || i.title,
              quantity: i.quantity,
              price_clp: Math.round((i.final_price || i.price || 0) / 100),
            };
          }),
          cartSummary: cartSummaryFromItems(cart.items, cart.item_count),
        };
      })
      .catch(function () {
        return null;
      });
  }

  function withLiveCart(cb) {
    fetchLiveCart().then(function (live) {
      var prev = cfg.page;
      if (live) {
        cfg.page = Object.assign({}, prev || {}, live);
      }
      try {
        cb(live);
      } finally {
        if (live) cfg.page = prev;
      }
    });
  }

  function buildMessage(intent) {
    var p = page();
    var name = customerName();
    var hi = greet();
    var who = name ? ', soy ' + name : '';
    var suffix = ' [ref:' + refTag() + ']' + cartPayloadTag(p);

    switch (intent) {
      case 'product':
        if (p.productTitle) {
          return (
            hi +
            who +
            ', consulto por ' +
            p.productTitle +
            (p.productPrice ? ' (' + p.productPrice + ')' : '') +
            '. ¿Precio, stock y envío a mi comuna?' +
            (p.productUrl ? ' ' + p.productUrl : '') +
            suffix
          );
        }
        break;
      case 'cart':
        if (p.cartCount > 0) {
          return (
            hi +
            who +
            ', necesito ayuda para cerrar mi carrito' +
            (p.cartSummary ? ' (' + p.cartSummary + ')' : '') +
            '. ¿Me mandas el link de compra?' +
            suffix
          );
        }
        return hi + who + ', quiero ayuda para elegir suplementos y cerrar mi compra.' + suffix;
      case 'shipping':
        return hi + who + ', ¿cuánto demora el envío y hay despacho mismo día en Santiago?' + suffix;
      case 'bulk':
        return hi + who + ', consulto por compra al granel o packs con mejor precio.' + suffix;
      case 'packs':
        return hi + who + ', ¿qué packs u ofertas recomiendan según mi meta?' + suffix;
      case 'collection':
        if (p.collectionTitle) {
          return hi + who + ', busco suplementos en ' + p.collectionTitle + '. ¿Qué me recomiendan?' + suffix;
        }
        break;
      case 'account':
        return hi + (name ? ', soy ' + name : '') + '. Quiero asesoría para mi próxima compra en Muscle Grenade.' + suffix;
      default:
        break;
    }
    return hi + who + ', tengo una consulta sobre suplementos en musclegrenade.cl.' + suffix;
  }

  function primaryIntent() {
    var p = page();
    if (p.type === 'product' && p.productTitle) return 'product';
    if (p.cartCount > 0) return 'cart';
    if (p.type === 'collection' && p.collectionTitle) return 'collection';
    if (p.type === 'customers/account') return 'account';
    return 'general';
  }

  function primaryLabel() {
    var intent = primaryIntent();
    if (intent === 'product') return 'Consultar este producto';
    if (intent === 'cart') return 'Ayuda con mi carrito';
    if (intent === 'collection') return 'Recomiéndame en esta categoría';
    if (intent === 'account') return 'Asesoría para mi próxima compra';
    return 'Hablar con Asesor MG';
  }

  function contextLine() {
    var p = page();
    if (p.type === 'product' && p.productTitle) {
      return 'Estás viendo: ' + p.productTitle;
    }
    if (p.cartCount > 0) {
      return 'Tu carrito: ' + p.cartCount + ' producto' + (p.cartCount === 1 ? '' : 's');
    }
    if (p.collectionTitle) return 'Categoría: ' + p.collectionTitle;
    return 'Respuestas por WhatsApp con IA · Muscle Grenade Chile';
  }

  function waUrl(text) {
    var num = String(cfg.number || '19567414430').replace(/\D/g, '');
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(text);
  }

  function track(intent) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'mg_whatsapp_sales', { intent: intent, page_type: page().type || '' });
      }
      if (typeof ttq !== 'undefined' && ttq.track) {
        ttq.track('ClickButton', { content_name: 'mg_whatsapp_' + intent });
      }
    } catch (e) {
      /* ignore */
    }
  }

  function openWhatsApp(intent, customText) {
    withLiveCart(function () {
      var resolvedIntent = intent === 'general' ? primaryIntent() : intent;
      var text = customText || buildMessage(resolvedIntent);
      if (customText && page().cartItems && page().cartItems.length && text.indexOf('[cart:') < 0) {
        text += cartPayloadTag();
      }
      track(intent || 'custom');
      if (page().cartCount > 0 && !customText) {
        try {
          var n = page().cartCount;
          var ok = window.confirm(
            'Se abrirá WhatsApp con tu carrito de ' + n + ' producto' + (n === 1 ? '' : 's') + ' para que el Asesor MG te mande el link de pago.'
          );
          if (!ok) return;
        } catch (e) {
          /* ignore */
        }
      }
      window.open(waUrl(text), '_blank', 'noopener,noreferrer');
    });
  }

  window.MG_OPEN_WHATSAPP_SALES = openWhatsApp;

  function bindTriggers(root) {
    root = root || document;
    root.querySelectorAll('[data-mg-wa-sales]').forEach(function (el) {
      if (el.dataset.mgWaBound) return;
      el.dataset.mgWaBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openWhatsApp(el.getAttribute('data-mg-wa-sales') || 'general');
      });
    });
  }

  function initWidget() {
    var fab = document.querySelector('[data-mg-sales-wa-fab]');
    var panel = document.querySelector('[data-mg-sales-wa-panel]');
    if (!fab || !panel) return;

    var primaryBtn = panel.querySelector('[data-mg-sales-wa-primary]');
    var ctxEl = panel.querySelector('[data-mg-sales-wa-context]');
    var input = panel.querySelector('[data-mg-sales-wa-input]');
    var closeBtn = panel.querySelector('[data-mg-sales-wa-close]');

    if (ctxEl) ctxEl.textContent = contextLine();
    if (primaryBtn) {
      primaryBtn.textContent = primaryLabel();
      primaryBtn.addEventListener('click', function () {
        openWhatsApp(primaryIntent());
      });
    }

    panel.querySelectorAll('[data-mg-sales-wa-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        openWhatsApp(chip.getAttribute('data-mg-sales-wa-chip'));
      });
    });

    if (input) {
      var form = panel.querySelector('[data-mg-sales-wa-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var t = (input.value || '').trim();
          if (!t) return openWhatsApp(primaryIntent());
          openWhatsApp('custom', greet() + (customerName() ? ', soy ' + customerName() : '') + '. ' + t + ' [ref:' + refTag() + ']');
        });
      }
    }

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('mg-sales-wa-open', open);
    }

    fab.addEventListener('click', function () {
      var opening = !panel.classList.contains('is-open');
      setOpen(opening);
      if (opening && ctxEl) {
        fetchLiveCart().then(function (live) {
          if (!live) return;
          cfg.page = Object.assign({}, cfg.page || {}, live);
          ctxEl.textContent = contextLine();
        });
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  function init() {
    initWidget();
    bindTriggers(document);
    document.addEventListener('shopify:section:load', function () {
      bindTriggers(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();